import { http } from "frontend/src/api/client";
var URL = "playlist-business-types";
var getMany = function (object) {
    return http.api
        .get(URL, { params: { isPublished: object === null || object === void 0 ? void 0 : object.isPublished } })
        .then(function (res) { return res.data.data; });
};
var changePublishStatus = function (_a) {
    var id = _a.id, publish = _a.publish;
    return http.api.get("".concat(URL, "/").concat(id, "/").concat(publish ? "publish" : "unpublish"));
};
var create = function (_a) {
    var title = _a.title, isPublished = _a.isPublished, image = _a.image;
    var data = new FormData();
    data.append("title", title);
    data.append("publishStatus", isPublished ? "published" : "unpublished");
    data.append("image", image);
    return http.api
        .post(URL, data)
        .then(function (res) { return res.data.data; });
};
export var playlistBusinessTypesApi = {
    getMany: getMany,
    create: create,
    changePublishStatus: changePublishStatus,
};
